import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../style/contact/contact.css";


function Contact(){
    const { t } = useTranslation();
    const [content, setContent] = useState({
        firstName:"",
        middleName:"",
        lastName:"",
        pronouns:"",
        email:"",
        phoneNumber:"",
        subject:"",
        message:""
    });

    function handleChange(event){
        const { name, value } = event.target
        setContent(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    function submitMessage(event){
        event.preventDefault()

        fetch("http://localhost:3000/support/contact-us", {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                "firstName": content.firstName,
                "middleName": content.middleName,
                "lastName": content.lastName,
                "pronouns": content.pronouns,
                "email": content.email,
                "phoneNumber": content.phoneNumber,
                "subject": content.subject,
                "message": content.message
            })
        })
        .then((response) => {
            if (response.ok) {
                alert(t('ContactPage.SuccessMessage'));
            }
            return response.json();
        })
        .then((result) => console.log(result));
    }

    return(
        <div className="container">
           <div className="contact-container">
                <h1>{t('ContactPage.Title')}</h1>
                <h5>{t('ContactPage.RequiredField')}</h5>
                <form className="contact-form" onSubmit={submitMessage}>
                    <h4>{t('ContactPage.FirstName')}</h4>
                    <input type="text" name="firstName" value={content.firstName} onChange={handleChange} pattern="[A-Za-z]{2,}" placeholder={t('ContactPage.FirstNamePlaceholder')} required/>
                    
                    <h4>{t('ContactPage.MiddleName')}</h4>
                    <input type="text" name="middleName" value={content.middleName} onChange={handleChange} pattern="[A-Za-z]{2,}" placeholder={t('ContactPage.MiddleNamePlaceholder')} />
                    
                    <h4>{t('ContactPage.LastName')}</h4>
                    <input type="text" name="lastName" value={content.lastName} onChange={handleChange} pattern="[A-Za-z]{2,}" placeholder={t('ContactPage.LastNamePlaceholder')} required/>
                    
                    <h4>{t('ContactPage.Pronouns')}</h4>
                    <select name="pronouns" value={content.pronouns} onChange={handleChange}>
                        <option value="">{t('ContactPage.PronounOptions.na')}</option>
                        <option value="heHim">{t('ContactPage.PronounOptions.heHim')}</option>
                        <option value="sheHer">{t('ContactPage.PronounOptions.sheHer')}</option>
                        <option value="theyThem">{t('ContactPage.PronounOptions.theyThem')}</option>
                        <option value="eyEm">{t('ContactPage.PronounOptions.eyEm')}</option>
                        <option value="veVer">{t('ContactPage.PronounOptions.veVer')}</option>
                        <option value="xeXem">{t('ContactPage.PronounOptions.xeXem')}</option>
                        <option value="zeZir">{t('ContactPage.PronounOptions.zeZir')}</option>
                        <option value="xieHir">{t('ContactPage.PronounOptions.xieHir')}</option>
                    </select>

                    <h4>{t('ContactPage.EmailAddress')}</h4>
                    <input type="text" name="email" value={content.email} onChange={handleChange} pattern="([A-Za-z0-9._%\-]{2,})+@([A-Za-z0-9.\-]{2,})+\.[a-z]{2,}$" placeholder={t('ContactPage.EmailPlaceholder')} required/>
                    
                    <h4>{t('ContactPage.PhoneNumber')}</h4>
                    <input type="text" name="phoneNumber" value={content.phoneNumber} onChange={handleChange} pattern="[0-9]{7,15}" placeholder={t('ContactPage.PhonePlaceholder')} />
                    
                    <h4>{t('ContactPage.Subject')}</h4>
                    <input type="text" name="subject" value={content.subject} onChange={handleChange} placeholder={t('ContactPage.SubjectPlaceholder')} required/>
                    
                    <h4>{t('ContactPage.Message')}</h4>
                    <textarea name="message" value={content.message} onChange={handleChange} placeholder={t('ContactPage.MessagePlaceholder')} required/>
                    <br />
                    
                    <input type="submit" value={t('ContactPage.Submit')}/>
                </form>
            </div>
        </div>
    );
}

export default Contact;